import React from "react";


export const AIUseIcon = ({color}: {color: string}):JSX.Element => {
    return (
        <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
            width="24px" height="24px" viewBox="0 0 400.000000 381.000000"
            preserveAspectRatio="xMidYMid meet">
        
            <g transform="translate(0.000000,381.000000) scale(0.100000,-0.100000)"
                fill={color || "#FFFFFF"} stroke="none">
                <path d="M1769 3585 c-500 -69 -968 -366 -1244 -789 -196 -301 -287 -602 -286
-951 1 -507 237 -1017 622 -1339 529 -445 1191 -552 1806 -292 123 52 299 156
408 241 97 75 274 257 337 346 234 327 348 672 348 1049 0 205 -21 329 -92
550 -112 346 -374 681 -707 903 -348 233 -787 337 -1192 282z m546 -135 c667
-144 1185 -667 1307 -1319 40 -215 27 -490 -33 -710 -168 -605 -680 -1079
-1302 -1203 -149 -30 -402 -32 -557 -4 -342 60 -655 229 -906 487 -188 195
-306 389 -389 644 -63 190 -79 296 -79 505 0 194 18 317 73 488 120 374 383
698 739 914 157 95 373 176 537 203 49 8 101 17 115 19 14 2 108 3 210 1 143
-2 208 -8 285 -25z"/>
                <path d="M1905 3371 c-163 -75 -148 -315 24 -376 56 -19 75 -19 135 2 94 34
158 142 137 233 -29 131 -172 199 -296 141z m112 -68 c3 -10 15 -25 26 -34 23
-19 14 -43 -14 -36 -30 8 -22 -16 11 -35 37 -21 40 -59 7 -85 -13 -10 -26 -26
-30 -36 -8 -22 -43 -18 -39 5 1 9 -6 18 -18 21 -24 6 -37 34 -22 49 8 8 15 8
27 -2 12 -10 15 -10 15 4 0 9 -5 16 -12 16 -19 0 -48 32 -48 52 0 10 10 29 23
41 13 12 26 30 30 40 3 9 13 17 22 17 9 0 18 -8 22 -17z"/>
                <path d="M1966 3231 c-4 -7 -5 -15 -2 -18 9 -9 19 4 14 18 -4 11 -6 11 -12 0z"/>
                <path d="M2010 3155 c0 -8 5 -15 10 -15 6 0 10 7 10 15 0 8 -4 15 -10 15 -5 0
-10 -7 -10 -15z"/>
                <path d="M1540 3187 c-95 -34 -229 -106 -247 -134 -13 -19 -13 -29 -5 -48 20
-43 49 -40 152 14 52 27 126 59 165 70 74 23 85 32 85 72 0 55 -45 63 -150 26z"/>
                <path d="M2312 3198 c-18 -18 -15 -63 6 -81 9 -8 40 -21 67 -27 28 -7 100 -36
162 -66 93 -46 116 -53 132 -44 25 13 36 51 23 77 -22 40 -279 153 -349 153
-16 0 -34 -5 -41 -12z"/>
                <path d="M965 2955 c-46 -25 -63 -44 -81 -91 -27 -71 2 -153 68 -195 43 -26
135 -23 175 7 52 39 68 71 68 134 0 63 -16 95 -68 134 -36 26 -122 32 -162 11z
m106 -105 c39 -21 12 -100 -34 -100 -27 0 -57 28 -57 52 0 51 43 73 91 48z"/>
                <path d="M2879 2948 c-72 -41 -101 -135 -65 -211 25 -52 68 -80 131 -85 87 -7
145 32 173 117 22 63 -21 151 -89 186 -40 21 -108 18 -150 -7z m127 -113 c32
-49 -22 -104 -74 -76 -29 16 -37 48 -18 76 23 34 70 34 92 0z"/>
                <path d="M1670 2907 c-56 -16 -105 -45 -144 -86 -17 -18 -44 -33 -65 -37 -136
-24 -246 -142 -258 -276 -4 -44 -11 -61 -27 -71 -43 -29 -89 -84 -114 -136
-28 -61 -40 -164 -24 -211 10 -29 9 -35 -18 -68 -79 -99 -78 -246 2 -331 26
-27 27 -29 11 -72 -18 -53 -13 -141 12 -190 22 -43 72 -96 108 -115 24 -13 27
-20 27 -62 0 -77 26 -148 73 -199 43 -47 105 -82 144 -83 15 0 36 -18 64 -53
83 -104 187 -154 306 -144 73 5 154 41 197 86 l29 30 40 -35 c78 -71 192 -99
296 -74 69 16 157 77 204 139 22 30 45 51 56 51 29 0 105 35 132 61 60 57 89
129 89 217 0 46 3 53 28 66 44 23 100 88 117 135 19 54 19 126 1 179 -14 39
-14 40 14 67 77 74 80 236 5 322 -29 34 -31 41 -22 73 15 57 3 158 -26 216
-14 28 -51 74 -81 102 -49 44 -56 55 -56 89 0 128 -117 258 -260 288 -19 4
-55 25 -79 47 -119 104 -273 115 -404 27 l-60 -40 -26 25 c-63 60 -198 89
-291 63z m142 -107 c21 -6 51 -22 68 -37 55 -46 60 -66 60 -243 l0 -160 -65 0
-65 0 0 99 0 98 -92 83 c-51 46 -97 87 -102 91 -24 20 72 78 129 79 17 0 47
-5 67 -10z m524 -25 c24 -14 44 -29 44 -33 0 -4 -45 -47 -100 -95 l-100 -88 0
-99 0 -100 -60 0 -60 0 0 173 c0 146 3 176 17 197 55 80 166 100 259 45z
m-790 -127 c16 -11 57 -48 92 -82 l62 -60 0 -108 c0 -145 3 -148 140 -148
l100 0 0 -100 0 -100 -62 0 -63 0 -127 127 -128 128 0 68 c0 59 -3 71 -25 92
-22 23 -31 25 -125 25 -61 0 -100 4 -100 10 0 6 10 31 21 56 46 96 150 141
215 92z m1012 7 c49 -21 81 -52 103 -100 30 -65 30 -65 -80 -65 -133 0 -145
-9 -142 -110 l2 -72 -128 -129 -127 -129 -63 0 -63 0 0 100 0 100 99 0 c129 0
131 2 131 150 l0 106 48 45 c133 127 148 134 220 104z m-1115 -338 l2 -57 160
-160 160 -159 88 -1 87 0 -2 -192 -3 -193 -106 -3 -105 -3 -69 -69 -69 -70
-194 0 -194 0 -28 30 c-33 36 -45 86 -30 139 18 67 34 71 88 20 25 -24 49 -47
52 -51 3 -3 23 -20 44 -37 28 -22 45 -29 60 -25 12 4 56 44 99 90 73 78 82 84
119 84 21 0 48 -5 60 -11 49 -26 114 42 87 93 -19 35 -28 38 -111 31 l-78 -6
0 120 c0 149 -5 156 -118 163 -73 5 -76 6 -83 34 -7 24 -4 32 16 48 14 11 25
30 25 44 0 51 -71 84 -101 48 -15 -18 -120 -91 -145 -101 -15 -6 -16 0 -11 45
8 66 31 115 75 158 43 42 78 53 160 51 l64 -2 1 -58z m1283 44 c46 -21 90 -72
110 -128 14 -41 19 -117 7 -111 -35 15 -113 68 -134 91 -44 44 -101 32 -114
-25 -5 -21 -1 -33 20 -54 21 -21 25 -32 20 -55 -6 -28 -8 -29 -73 -29 -37 0
-78 -6 -92 -13 -24 -12 -25 -17 -30 -137 l-5 -125 -80 0 c-88 0 -102 -5 -115
-41 -21 -53 38 -106 94 -84 65 24 86 15 171 -71 44 -44 88 -85 98 -90 24 -14
50 2 135 85 l74 71 19 -23 c42 -52 33 -152 -18 -191 -24 -20 -39 -21 -218 -21
l-192 0 -65 70 -65 70 -107 0 -106 0 0 195 0 195 83 0 82 0 160 160 160 160 1
53 c0 28 1 55 2 60 4 15 137 7 178 -12z m-1414 -403 c23 -24 34 -28 82 -28
l56 0 0 -118 0 -118 -40 -39 -39 -38 -75 66 c-67 61 -78 67 -118 67 -55 0 -84
20 -97 67 -21 73 14 139 102 198 l52 34 25 -31 c14 -18 37 -44 52 -60z m1578
-18 c30 -42 36 -99 16 -138 -21 -40 -44 -52 -98 -52 -40 0 -49 -5 -98 -56 -81
-82 -85 -83 -131 -38 l-39 38 0 118 0 118 53 0 c62 0 85 14 127 75 l31 45 59
-40 c32 -22 68 -53 80 -70z m-950 -600 l0 -100 -186 0 -186 0 -82 -79 -81 -80
-33 16 c-46 22 -71 69 -74 139 l-3 59 171 3 170 2 63 70 62 70 90 0 89 0 0
-100z m352 30 l63 -70 173 0 172 0 0 -47 c0 -81 -56 -163 -111 -163 -7 0 -47
34 -90 75 l-77 75 -181 0 -181 0 0 100 0 100 84 0 85 0 63 -70z m-352 -300 c0
-58 -15 -93 -57 -131 -45 -42 -74 -53 -144 -53 -83 0 -147 34 -189 101 l-29
46 37 43 37 43 173 1 172 0 0 -50z m493 8 c34 -41 35 -43 20 -73 -40 -79 -107
-118 -204 -119 -56 0 -73 4 -108 27 -59 39 -81 80 -81 150 l0 57 169 0 169 0
35 -42z"/>
                <path d="M710 2560 c-27 -27 -25 -54 5 -78 l25 -20 -35 -60 c-39 -68 -99 -237
-91 -258 4 -10 23 -14 61 -14 52 0 55 1 55 24 0 28 51 166 75 203 15 23 18 23
34 9 21 -19 52 -21 69 -4 16 16 16 190 0 206 -7 7 -44 12 -95 12 -70 0 -86 -3
-103 -20z"/>
                <path d="M3088 2569 c-25 -14 -26 -179 -2 -203 20 -20 48 -20 64 -1 7 8 17 15
22 15 14 0 76 -136 89 -196 l12 -54 54 0 c48 0 53 2 53 23 0 47 -56 196 -100
268 l-28 47 24 11 c17 7 24 19 24 39 0 48 -26 62 -116 62 -43 0 -87 -5 -96
-11z"/>
                <path d="M593 2030 c-81 -19 -143 -101 -143 -190 0 -50 30 -130 49 -130 18 0
71 75 65 90 -18 41 -15 67 11 98 22 27 34 32 69 32 23 0 47 -5 52 -10 7 -7 21
3 43 30 31 39 32 42 15 55 -20 14 -93 36 -116 34 -7 -1 -28 -5 -45 -9z"/>
                <path d="M3265 2021 c-80 -37 -120 -107 -113 -196 9 -106 86 -175 197 -175
131 0 207 79 199 206 -3 52 -9 70 -34 101 -61 77 -164 103 -249 64z m105 -71
c0 -10 10 -24 23 -31 33 -17 57 -50 57 -80 0 -31 -32 -75 -60 -84 -11 -4 -20
-15 -20 -26 0 -14 -7 -19 -25 -19 -18 0 -25 5 -25 20 0 16 -7 20 -30 20 -23 0
-30 5 -30 19 0 10 7 21 15 25 9 3 15 19 15 41 0 22 -6 38 -15 41 -8 4 -15 17
-15 30 0 20 5 24 30 24 23 0 30 4 30 20 0 15 7 20 25 20 18 0 25 -5 25 -20z"/>
                <path d="M3330 1840 c0 -35 3 -40 23 -40 45 0 65 50 28 70 -38 20 -51 13 -51
-30z"/>
                <path d="M763 1920 c-27 -25 -31 -34 -26 -63 9 -57 -49 -116 -104 -105 -16 3
-82 -55 -83 -73 0 -13 54 -29 97 -29 103 0 182 72 191 173 4 51 -17 127 -35
127 -4 0 -22 -14 -40 -30z"/>
                <path d="M614 1537 c-7 -19 40 -157 87 -252 22 -44 35 -81 29 -83 -41 -14 -51
-61 -20 -92 17 -17 33 -20 98 -20 110 0 113 4 110 120 l-3 95 -29 3 c-16 2
-33 -1 -39 -7 -6 -6 -15 -11 -19 -11 -13 0 -75 137 -91 200 l-14 55 -52 3
c-37 2 -53 -1 -57 -11z"/>
                <path d="M3262 1498 c-7 -29 -29 -88 -49 -131 -28 -60 -40 -76 -52 -71 -74 31
-91 14 -91 -92 0 -107 6 -114 108 -114 92 0 122 15 122 61 0 21 -7 32 -24 40
l-24 11 38 72 c43 80 94 225 88 253 -2 14 -14 19 -54 21 l-50 3 -12 -53z"/>
                <path d="M985 1020 c-72 -22 -123 -110 -109 -186 8 -44 57 -102 101 -120 106
-45 223 35 223 153 0 44 -32 106 -69 132 -34 25 -103 34 -146 21z m89 -116
c25 -25 20 -72 -8 -85 -57 -26 -103 20 -77 77 13 28 60 33 85 8z"/>
                <path d="M2906 1020 c-41 -13 -83 -56 -102 -105 -37 -98 48 -215 156 -215 40
0 102 32 129 66 58 73 40 177 -40 236 -29 21 -103 31 -143 18z m96 -117 c22
-20 23 -42 2 -71 -22 -32 -73 -27 -93 9 -13 24 -13 29 2 53 20 30 61 35 89 9z"/>
                <path d="M1320 703 c-20 -8 -39 -34 -40 -55 0 -36 134 -117 274 -164 107 -37
136 -30 136 32 0 39 -10 47 -84 69 -59 16 -196 80 -238 110 -24 16 -25 16 -48
8z"/>
                <path d="M1927 696 c-116 -42 -169 -166 -121 -285 69 -173 331 -161 392 18 57
166 -106 326 -271 267z m93 -70 c0 -8 17 -31 37 -51 38 -38 38 -38 15 -48 -17
-8 -26 -6 -40 6 -23 21 -56 22 -76 1 -21 -20 -20 -43 1 -66 17 -19 73 -25 73
-8 0 15 35 29 50 20 20 -12 -2 -57 -35 -72 -17 -7 -25 -19 -25 -35 0 -20 -5
-24 -22 -21 -14 2 -24 11 -26 24 -2 12 -14 27 -27 34 -33 18 -58 73 -50 110 4
16 21 41 38 56 18 15 35 35 39 45 8 22 48 26 48 5z"/>
                <path d="M2623 695 c-42 -29 -179 -93 -235 -110 -32 -9 -65 -23 -73 -31 -33
-33 -8 -94 38 -94 53 0 288 106 337 153 23 20 25 45 7 68 -19 25 -50 31 -74
14z"/>
            </g>
        </svg>

    );
};
